const listenerRegistry = new WeakMap();

export const supportChatListeners = (socket, dispatch) => {
  if (listenerRegistry.has(socket)) {
    const prev = listenerRegistry.get(socket);
    socket.off("supportChat:newMessage", prev.newMessage);
    socket.off("supportChat:messagePatched", prev.messagePatched);
  }

  const newMessageHandler = (data) => {
    dispatch({ type: "supportChat/addSocketMessage", payload: data });
  };

  const messagePatchedHandler = (data) => {
    dispatch({
      type: "supportChat/applySupportMessagePatch",
      payload: data,
    });
  };

  socket.on("supportChat:newMessage", newMessageHandler);
  socket.on("supportChat:messagePatched", messagePatchedHandler);
  listenerRegistry.set(socket, {
    newMessage: newMessageHandler,
    messagePatched: messagePatchedHandler,
  });
};
